export const MAU_PHIEU_THU_CAU_HINH_SELECT_ALL =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_ALL";
export const MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_SUCCESS =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_SUCCESS";
export const MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_ERROR =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_ALL_ERROR";

export const MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID";
export const MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_SUCCESS =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_SUCCESS";
export const MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_ERROR =
  "MAU_PHIEU_THU_CAU_HINH_SELECT_BY_ID_ERROR";

export const MAU_PHIEU_THU_CAU_HINH_INSERT = "MAU_PHIEU_THU_CAU_HINH_INSERT";
export const MAU_PHIEU_THU_CAU_HINH_INSERT_SUCCESS =
  "MAU_PHIEU_THU_CAU_HINH_INSERT_SUCCESS";
export const MAU_PHIEU_THU_CAU_HINH_INSERT_ERROR =
  "MAU_PHIEU_THU_CAU_HINH_INSERT_ERROR";

export const MAU_PHIEU_THU_CAU_HINH_UPDATE = "MAU_PHIEU_THU_CAU_HINH_UPDATE";
export const MAU_PHIEU_THU_CAU_HINH_UPDATE_SUCCESS =
  "MAU_PHIEU_THU_CAU_HINH_UPDATE_SUCCESS";
export const MAU_PHIEU_THU_CAU_HINH_UPDATE_ERROR =
  "MAU_PHIEU_THU_CAU_HINH_UPDATE_ERROR";

export const MAU_PHIEU_THU_CAU_HINH_DELETE = "MAU_PHIEU_THU_CAU_HINH_DELETE";
export const MAU_PHIEU_THU_CAU_HINH_DELETE_SUCCESS =
  "MAU_PHIEU_THU_CAU_HINH_DELETE_SUCCESS";
export const MAU_PHIEU_THU_CAU_HINH_DELETE_ERROR =
  "MAU_PHIEU_THU_CAU_HINH_DELETE_ERROR";

export const MAU_PHIEU_THU_CAU_HINH_SHOW_HIDE_EDIT_MODAL =
  "MAU_PHIEU_THU_CAU_HINH_SHOW_HIDE_EDIT_MODAL";
export const MAU_PHIEU_THU_CAU_HINH_RESET_REQUEST =
  "MAU_PHIEU_THU_CAU_HINH_RESET_REQUEST";
